<template>
    <section id="webtoon" >    
        <div class="container" >
            <h2 class="my-3 text-capitalize font-weight-bold title" style="margin-top:50px !important;">Webtoon</h2> 
            <carousel :per-page="1" :adjustableHeight="ture" :mouse-drag="false" >
              <slide v-for="(item, index) in items" :key="index" >
                <div class="example-slide" v-bind:class="'style-' + ((index ) + 1)" >
                  <img  :src="item.image" :alt="item.name" class="img-fluid"  style="width:100%;">
                </div> 
              </slide>
            </carousel>
        </div>  
    </section>
</template>

<script>
import Vue from 'vue';
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
  export default {
       data () {
        return {
            items: [
              {image: 'https://buffimgs.plaync.com/buff/banner/201905/db103b1b3434e7e7be4d6e4b08c9e765b8a8e907bef73e0215253f017b8a9a67.jpg'},
            {image: 'https://buffimgs.plaync.com/buff/banner/201905/df0a3df0a5d3b366f0cf193097fc042d0c96ff7c8ff37b83654b0e7770eb7ce7.jpg'},
            {image: 'https://buffimgs.plaync.com/buff/banner/201905/129f2cf8d9be7826c9cf9a74ce31bb067a90b415ac997d8eda64c2cced061932.jpg'},
            {image: 'https://buffimgs.plaync.com/buff/banner/201905/df0a3df0a5d3b366f0cf193097fc042d0c96ff7c8ff37b83654b0e7770eb7ce7.jpg'},
            {image: 'https://buffimgs.plaync.com/buff/banner/201905/df0a3df0a5d3b366f0cf193097fc042d0c96ff7c8ff37b83654b0e7770eb7ce7.jpg'},
            ]
        }
    }
  };
</script>

<style>
  .example-slide {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;


  }


</style>



// WEBPACK FOOTER //
// src/components/Webtoon.vue